/* =========================================================
   GLAM GRACE – Interaktionen im Stil von Victoria Beckham
   Favoriten (Herz), Galerie-Pfeile, Groesse waehlen
   ========================================================= */
(function () {
  'use strict';

  var EN = /^en/i.test(document.documentElement.lang || '');
  function T(de, en) { return EN ? en : de; }

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var FAV_KEY = 'gg-favorites';

  /* ---------- Hilfsfunktionen ---------- */
  function decode(str) {
    var t = document.createElement('textarea');
    t.innerHTML = String(str || '');
    return t.value.replace(/<[^>]*>/g, '');
  }

  function formatNumber(num, decimals, thousands, decimal) {
    var parts = num.toFixed(decimals).split('.');
    var int = parts[0], out = '';
    while (int.length > 3) { out = thousands + int.slice(-3) + out; int = int.slice(0, -3); }
    parts[0] = int + out;
    return parts.join(decimal);
  }

  function formatMoney(cents) {
    var fmt = decode(window.ggMoneyFormat || '€{{amount_with_comma_separator}}');
    var n = Number(cents || 0) / 100;
    return fmt.replace(/[{][{] *([a-z_]+) *[}][}]/, function (_, key) {
      switch (key) {
        case 'amount': return formatNumber(n, 2, ',', '.');
        case 'amount_no_decimals': return formatNumber(n, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return formatNumber(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return formatNumber(n, 2, '’', '.');
        default: return formatNumber(n, 2, '.', ',');
      }
    });
  }

  function sizedImage(src, width) {
    if (!src) return '';
    var url = String(src);
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function pop(node) {
    node.classList.remove('gg-pop');
    void node.offsetWidth;
    node.classList.add('gg-pop');
  }

  /* ---------- Favoriten ---------- */
  function getFavs() {
    try {
      var list = JSON.parse(window.localStorage.getItem(FAV_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function setFavs(list) {
    try {
      window.localStorage.setItem(FAV_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function toggleFav(handle) {
    var list = getFavs();
    var i = list.indexOf(handle);
    if (i === -1) list.unshift(handle);
    else list.splice(i, 1);
    setFavs(list);
    return i === -1;
  }

  function syncFavs() {
    var list = getFavs();
    document.querySelectorAll('[data-gg-fav]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-gg-fav')) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? T('Aus Favoriten entfernen', 'Remove from favorites') : T('Zu Favoriten hinzufügen', 'Add to favorites'));
    });
    document.querySelectorAll('.header__icon--wishlist').forEach(function (icon) {
      icon.classList.toggle('has-items', list.length > 0);
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-gg-fav]');
    if (!btn) return;
    event.preventDefault();
    var handle = btn.getAttribute('data-gg-fav');
    var added = toggleFav(handle);
    syncFavs();
    pop(btn);
    var heart = document.querySelector('.header__icon--wishlist');
    if (heart && added) pop(heart);

    var card = btn.closest('.gg-fav-card');
    if (card && !added) {
      card.style.transition = 'opacity .4s ease, transform .4s ease';
      card.style.opacity = '0';
      card.style.transform = 'scale(.96)';
      setTimeout(function () {
        card.remove();
        var empty = document.querySelector('[data-gg-favs-empty]');
        if (empty && !document.querySelector('.gg-fav-card')) empty.hidden = false;
      }, 400);
    }
  });

  window.addEventListener('storage', function (e) {
    if (e.key === FAV_KEY) syncFavs();
  });

  function addHeaderHeart() {
    if (document.querySelector('.header__icon--wishlist')) return;
    var cart = document.getElementById('cart-icon-bubble');
    if (!cart || !cart.parentNode) return;
    var a = document.createElement('a');
    a.href = ROOT + 'pages/favoriten';
    a.className = 'header__icon header__icon--wishlist link focus-inset';
    var hidden = el('span', 'visually-hidden', T('Favoriten', 'Favorites'));
    a.appendChild(hidden);
    cart.parentNode.insertBefore(a, cart);
  }

  function renderFavPage() {
    var grid = document.querySelector('[data-gg-favs-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-gg-favs-empty]');
    var list = getFavs();
    grid.innerHTML = '';
    if (!list.length) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    Promise.all(
      list.map(function (handle) {
        return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      var valid = products.filter(Boolean);
      if (!valid.length) {
        if (empty) empty.hidden = false;
        return;
      }
      valid.forEach(function (p) {
        var card = el('div', 'gg-fav-card');
        var media = el('a', 'gg-fav-card__media');
        media.href = p.url;
        if (p.featured_image) {
          var img = document.createElement('img');
          img.src = sizedImage(p.featured_image, 800);
          img.alt = p.title;
          img.loading = 'lazy';
          media.appendChild(img);
        }
        var fav = el('button', 'gg-fav-toggle is-active');
        fav.type = 'button';
        fav.setAttribute('data-gg-fav', p.handle);
        fav.setAttribute('aria-pressed', 'true');
        fav.setAttribute('aria-label', T('Aus Favoriten entfernen', 'Remove from favorites'));
        var name = el('a', 'gg-fav-card__name', p.title);
        name.href = p.url;
        var price = el('p', 'gg-fav-card__price', formatMoney(p.price));
        card.appendChild(media);
        card.appendChild(fav);
        card.appendChild(name);
        card.appendChild(price);
        grid.appendChild(card);
      });
    });
  }

  function placeProductHeart() {
    document.querySelectorAll('.product__info-container > .gg-fav-toggle').forEach(function (btn) {
      var container = btn.parentNode;
      var title = container.querySelector('.product__title');
      if (title) title.appendChild(btn);
    });
  }

  /* ---------- Galerie: Pfeile links/rechts ---------- */
  function initGalleryArrows() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      var viewer = gallery.querySelector('[id^=GalleryViewer]');
      var thumbs = gallery.querySelectorAll('[id^=GalleryThumbnails] button.thumbnail');
      if (!viewer || thumbs.length < 2 || viewer.querySelector('.gg-gal-arrow')) return;

      function go(step) {
        var buttons = Array.prototype.slice.call(
          gallery.querySelectorAll('[id^=GalleryThumbnails] button.thumbnail')
        );
        var current = buttons.findIndex(function (b) { return b.getAttribute('aria-current') === 'true'; });
        if (current === -1) current = 0;
        var next = (current + step + buttons.length) % buttons.length;
        buttons[next].click();
      }

      [['prev', T('Vorheriges Bild', 'Previous image'), -1], ['next', T('Nächstes Bild', 'Next image'), 1]].forEach(function (cfg) {
        var b = el('button', 'gg-gal-arrow gg-gal-arrow--' + cfg[0]);
        b.type = 'button';
        b.setAttribute('aria-label', cfg[1]);
        b.addEventListener('click', function (e) {
          e.preventDefault();
          go(cfg[2]);
        });
        viewer.appendChild(b);
      });
    });
  }

  /* ---------- Groesse waehlen ---------- */
  var sizeGuardAdded = false;

  function initSelectSize() {
    if (/[?&]variant=/.test(window.location.search)) return;
    document.querySelectorAll('product-info').forEach(function (info) {
      var fieldsets = info.querySelectorAll('variant-selects fieldset');
      if (fieldsets.length !== 1) return;
      var radios = fieldsets[0].querySelectorAll('input[type=radio]');
      if (radios.length < 2) return;
      radios.forEach(function (r) { r.checked = false; });
      info.setAttribute('data-gg-needs-size', '');
      var label = info.querySelector('.product-form__submit span');
      if (label) label.textContent = T('Größe wählen', 'Select size');
    });

    if (sizeGuardAdded) return;
    sizeGuardAdded = true;

    document.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('variant-selects input[type=radio]')) return;
      var info = e.target.closest('product-info');
      if (info) info.removeAttribute('data-gg-needs-size');
    }, true);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.closest || !form.closest('product-form')) return;
      var info = form.closest('product-info') || document.querySelector('product-info');
      if (!info) return;
      var fieldset = info.querySelector('variant-selects fieldset');
      if (!fieldset || fieldset.querySelector('input[type=radio]:checked')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      fieldset.classList.remove('gg-size-hint');
      void fieldset.offsetWidth;
      fieldset.classList.add('gg-size-hint');
      setTimeout(function () { fieldset.classList.remove('gg-size-hint'); }, 2400);
    }, true);
  }

  /* ---------- Start ---------- */
  function init() {
    addHeaderHeart();
    placeProductHeart();
    initGalleryArrows();
    initSelectSize();
    renderFavPage();
    syncFavs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();